// (function () {
//   if (!window.PVSTORIES || !PVSTORIES.ajaxUrl) return;

//   function pingSlide(slide) {
//     if (!slide) return;

//     var storiesPostId = slide.getAttribute("data-stories-post-id");
//     var idx = slide.getAttribute("data-index");
//     if (!storiesPostId || idx === null || idx === "") return;

//     var fd = new FormData();
//     fd.append("action", "pv_story_ping");
//     fd.append("stories_post_id", String(storiesPostId));
//     fd.append("index", String(idx));

//     fetch(PVSTORIES.ajaxUrl, {
//       method: "POST",
//       body: fd,
//       credentials: "same-origin",
//     })
//       .then((r) => r.json())
//       .then((data) => {
//         if (data?.success && typeof data.data?.views !== "undefined") {
//           var el = slide.querySelector(".stories__views-count");
//           if (el) el.textContent = String(data.data.views);
//         }
//       })
//       .catch(console.error);
//   }

//   window.PVSTORIES_pingSlide = pingSlide;
// })();
(function () {
  if (!window.PVSTORIES || !PVSTORIES.ajaxUrl) return;

  function pingSlide(slide) {
    if (!slide) return;

    var storiesPostId = slide.getAttribute("data-stories-post-id");
    var storyId = slide.getAttribute("data-story-id");

    if (!storiesPostId || !storyId) return;

    var fd = new FormData();
    fd.append("action", "pv_story_ping");
    fd.append("stories_post_id", String(storiesPostId));
    fd.append("story_id", String(storyId));

    fetch(PVSTORIES.ajaxUrl, {
      method: "POST",
      body: fd,
      credentials: "same-origin",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.success && typeof data.data?.views !== "undefined") {
          var el = slide.querySelector(".stories__views-count");
          if (el) el.textContent = String(data.data.views);
        }
      })
      .catch(console.error);
  }

  window.PVSTORIES_pingSlide = pingSlide;
})();